import {computed, override} from "mobx";
import {ANALYTICS} from "../../../../../third-party-services/analytics/analytics-consts";
import {NewMatchesFilterTabModel} from "./new-matches-filter.tab-model";
import type {BaseLinkModel} from "../../../../../infrastructure/models/link/base-link-model";
import {COMPETITION_CONTAINER} from "../../../../../containers/competition-container/competition-container.consts";
import {ENTITY_SCORES} from "../../../../../widgets/entity-scores-widget/entity-scores-widget.consts";
import {NEW_COMPETITOR_CONTAINER} from "../../../../../containers/competitor-container/competitor-container.consts";

export class NewMatchesFilterFixturesTabModel extends NewMatchesFilterTabModel {
  @computed get linkModel(): BaseLinkModel {
    const linkModel: BaseLinkModel = this.entity ? new this.linkModelType(this.entity.id, this.entity.sport.nameForURL, this.entity.nameForURL, NEW_COMPETITOR_CONTAINER.FILTERS.matches, super.itemHashParams(ENTITY_SCORES.URL_FILTERS.fixtures), this.entity.isFollow) : null;
    linkModel.replace = true;
    return linkModel;
  }

  @override get isVisible(): Boolean {
    return true;
  }

  get isActive(): Boolean {
    const isDefaultMatches = !this.isWidget && this.currentLinkModel.params.page === COMPETITION_CONTAINER.FILTERS.matches && !this.currentLinkModel.hashParams?.results;
    const isFixtures: Boolean = this.currentLinkModel.hashParams?.fixtures === ENTITY_SCORES.URL_FILTERS.fixtures;

    return isFixtures || isDefaultMatches;
  }

  get analyticsName(): Object {
    return ANALYTICS.TAB_NAMES.fixtures;
  }

  get eventName(): String {
    return null;
  }

  get elementId(): String {
    return 'navigation-tabs_fixtures';
  }
}
